import clientRequest from '@/lib/client-request';

export interface MaintenanceFeature {
  title: string;
  content: string;
  is_maintenance: boolean;
}

export interface MaintenanceStatus {
  [key: string]: MaintenanceFeature;
}

export function getSystemConfig(
  name: string,
): Promise<DataResponse<MaintenanceStatus>> {
  return clientRequest.get(`/system/config/${name}`);
}
